import React, { useContext } from 'react';
import Chart from 'react-google-charts';

import { Card, CardHeader } from '@material-ui/core';
import DashboardContext from 'src/pages/Private/Dashboard/context';
import { defaultChartOptions } from 'src/utils/charts';

const CollaboratorBenefitSolicitationsChart: React.FC = () => {
  const {
    chartsInfo: { benefitsSolicitationsIfepaf },
  } = useContext(DashboardContext);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        style={{ color: '#01CB98' }}
        title="IFEPAF"
        subheader="BENEFÍCIOS UTILIZADOS"
      />

      <Chart
        chartType="ColumnChart"
        data={benefitsSolicitationsIfepaf}
        options={defaultChartOptions}
      />
    </Card>
  );
};

export default CollaboratorBenefitSolicitationsChart;
